import moment from "moment";
import useApi from "../../../hooks/useApi";
import { useState, useEffect } from "react";
import { API_ROUTES } from "../../../api";
import Card from "../Card";
import { SnakeLoader } from "../../Loader";
import useCommonStore from "../../../store/store";
import { getUTCDate } from "../../../utils/dateFormatter";

const CancelledBookings = ({ selectedDate,handleBookingDetail }: any) => {
  const [bookingData, setBookingData] = useState([]);
  const {homestayData} = useCommonStore();

  const {
    data: cancelledBookingData,
    error,
    loading,
    apiClient: cancelledBookingClient,
  } = useApi();

  const getCancelledBooking = async () => {
    const url = API_ROUTES.BOOKINGS;
    const options = {
      params: {
        type:"cancelled",
        date: getUTCDate(selectedDate),
        homeStayId : homestayData?._id
      },
    };
    await cancelledBookingClient(url, options);
  };

  useEffect(() => {
    getCancelledBooking();
  }, [selectedDate,homestayData]);

  useEffect(() => {
    if (cancelledBookingData?.data) {
      setBookingData(cancelledBookingData?.data);
    }
  }, [cancelledBookingData]);

  return (
    <div className="flex flex-col gap-y-5">
      {loading && <SnakeLoader />}
      {!loading &&
        bookingData?.length > 0 &&
        bookingData?.map((booking: any) => {
          return (
            <Card
              handleBookingDetail={handleBookingDetail}
              bookingData={booking}
            />
          );
        })}

      {!loading && bookingData?.length === 0 && (
        <div className="flex self-center justify-between items-center shadow-xl px-6 py-4">
          <p className="font-inter font-bold text-[16px] leading-[15px] tracking-[0.5px] text-[#F75D37]">
            No Booking found
          </p>
        </div>
      )}
    </div>
  );
};

export default CancelledBookings;
